import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

import "vuejs-dialog/dist/vuejs-dialog.min.css";
import "vue-toastification/dist/index.css";
import "../app/core-module/assets/scss/customstyle.sass";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: false,
  theme: {
    themes: {
      light: {
        primary: "#5928E5",
        primaryDark: "#9373FF",
        primaryLight: "#F5F1FF",

        secondary: "#0E0E0E",
        secondaryDark: "#0E0E0E",
        secondaryLight: "#F1F1F1",

        accent: "#69F0AE",
        error: "#FF5252",
        warning: "#FB8C00",

        info: "#2196F3",
        infoLight: "#ECFBFF",
        infoDark: "#457482",

        success: "#5AB558",
        successDark: "#55845A",
        successLight: "#EDFFF0",

        light: "#FFFCFA",
        dark: "#2D2D2D",
        bg: "#F8F8F8",

        textLight: "#281166",

        langSwitch: "#e6e6e6",
        button: "#FFFFFF",
        card: "#FFFFFF",
      },
      dark: {
        primary: "#9373FF",
        button: "#1E1E1E",
        card: "#1E1E1E",
      },
    },
  },
});
